import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocale } from '../../i18n/locale-context.js';
const OPTIONS = [
    {
        kind: 'none',
        labelKey: 'export.erasure_composition.option.none.label',
        descriptionKey: 'export.erasure_composition.option.none.description',
        useCaseKey: 'export.erasure_composition.option.none.use_case',
    },
    {
        kind: 'erase-holder-only',
        labelKey: 'export.erasure_composition.option.erase_holder_only.label',
        descriptionKey: 'export.erasure_composition.option.erase_holder_only.description',
        useCaseKey: 'export.erasure_composition.option.erase_holder_only.use_case',
    },
    {
        kind: 'erase-phg-only',
        labelKey: 'export.erasure_composition.option.erase_phg_only.label',
        descriptionKey: 'export.erasure_composition.option.erase_phg_only.description',
        useCaseKey: 'export.erasure_composition.option.erase_phg_only.use_case',
    },
    {
        kind: 'erase-both',
        labelKey: 'export.erasure_composition.option.erase_both.label',
        descriptionKey: 'export.erasure_composition.option.erase_both.description',
        useCaseKey: 'export.erasure_composition.option.erase_both.use_case',
    },
];
export function ErasureCompositionStep(props) {
    const { t } = useLocale();
    return (_jsxs("section", { "aria-labelledby": "erasure-heading", children: [_jsx("h3", { id: "erasure-heading", children: t('export.erasure_composition.heading') }), _jsx("p", { children: t('export.erasure_composition.body') }), _jsxs("p", { children: [_jsx("strong", { children: t('export.erasure_composition.distinction_note_label') }), ' ', t('export.erasure_composition.distinction_note_body')] }), _jsx("ul", { "aria-label": t('export.erasure_composition.options_aria_label'), children: OPTIONS.map((opt) => (_jsxs("li", { children: [_jsx("button", { type: "button", onClick: () => props.onSelectComposition(opt.kind), children: _jsx("strong", { children: t(opt.labelKey) }) }), _jsx("p", { children: t(opt.descriptionKey) }), _jsx("p", { children: _jsx("em", { children: t(opt.useCaseKey) }) })] }, opt.kind))) }), _jsx("button", { type: "button", onClick: props.onCancel, children: t('export.erasure_composition.cancel') })] }));
}
//# sourceMappingURL=erasure-composition-step.js.map